import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The upcoming month right out from hell!",
  "description": "",
  "published": "2010-05-31T00:00:00.000Z",
  "redirect_from": ["/blog/the-upcoming-month-right-out-from-hell/swizec/1351"],
  "categories": "Hell, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`That is correct, the exam season is upon us once again.`}</p>
    <p>{`It's going to be a hellish few weeks and I'm already dreading climbing out of bed each and every day respectfully. Horrible horrible times are afoot.`}</p>
    <p>{`This week I'm facing two midterms, one somewhat long paper and having to defend my homework before scrutiny. Next week it's three rather not very easy exams. Yikes!`}</p>
    <p>{`And then nobody knows! I fully expect the one exam that's scheduled and the three oral exams partaining to the exams that are next week. Hoorah!`}</p>
    <p>{`Oh well, the exam season will behave like the drunk daddy in a particular song methinks.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/e95abd04-fee4-4075-9f46-1789f8e79607/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=e95abd04-fee4-4075-9f46-1789f8e79607",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      